<div [formGroup]="formGroup">
  <div>
    <mat-form-field>
      <input id="anmelderNavn" matInput placeholder="Navn" aria-label="Navn" formControlName="navn" />
      @if (formGroup.controls.navn.hasError('maxlength')) {
        <mat-error> Navn er for langt. </mat-error>
      }
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <input id="tlfnr" matInput placeholder="Telefonnr." aria-label="Telefon Nummer" formControlName="telefonnr" />
      @if (formGroup.controls.telefonnr.hasError('maxlength')) {
        <mat-error> Telefonnr. er for langt. </mat-error>
      }
    </mat-form-field>
  </div>
</div>
